import { getNextApiUrl } from '@/utils/next-api';
import { useUnleash } from '@/unleash';
import { useGetUserStatus } from '@/userStatus/hooks';

export const useRegisterLimitations = () => {
  const { data: regLimitations, isReady } = useUnleash('web.reg.limitation');
  const isNewRegActive = regLimitations?.isNewRegActive;
  const { isAnonymous } = useGetUserStatus();

  const loginLink = '/auth';

  const logoutLink = (query: string = '') => {
    return getNextApiUrl(`auth/logout${query}`);
  };

  // /register is now a route only accessible when user has an auth token.
  // so user should be logged in in order to use it.
  const newRegLink = isAnonymous ? getNextApiUrl(`auth/login`) : '/register';

  const registerLink = isNewRegActive
    ? newRegLink
    : getNextApiUrl('auth/register');

  return {
    loginLink,
    isNewRegActive,
    isReady,
    logoutLink,
    registerLink,
  };
};
